import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { VonMessageService } from '@von-development-studio/primeng-message-service';
import { SelectItem } from 'primeng/api';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseService } from 'src/app/core/base/base.service';
import { RestService } from 'src/app/core/service/rest.service';
import { AdminLocationModel } from 'src/app/model/admin/location';
import { AdminLocationViewModel } from 'src/app/model/admin/location.view';
import { BaseModalModel } from 'src/app/model/core/base-modal';
import { KhuyanaSelectItemModel } from 'src/app/model/core/khuyana-select-item.model';
import { adminLocationActions } from 'src/app/store/admin/location/admin-location.action';
import { environment } from 'src/environments/environment';
import { LOCATION_CONSTANTS } from './admin-location.constants';

@Injectable({
  providedIn: 'root',
})
export class AdminLocationService extends BaseService {
  private readonly screen = LOCATION_CONSTANTS;

  constructor(
    protected store: Store<any>,
    protected rest: RestService,
    protected message: VonMessageService
  ) {
    super();
  }

  getLocationStore = (): Observable<AdminLocationViewModel[]> =>
    this.store.select('admin', 'location', 'result');

  getLocationModal = (): Observable<BaseModalModel<AdminLocationModel>> =>
    this.store.select('admin', 'location', 'modal');

  openModal = ($event?: AdminLocationModel) => {
    const modalInfo = {} as BaseModalModel<AdminLocationModel>;
    modalInfo.isVisible = true;
    if (!$event) {
      modalInfo.title = this.screen.actions.add;
      modalInfo.value = {} as AdminLocationModel;
    } else {
      modalInfo.title = this.screen.actions.edit;
      modalInfo.value = { ...$event };
    }
    this.store.dispatch(adminLocationActions.setLocationAction(modalInfo));
  };

  readLocations = (): Observable<AdminLocationModel[]> =>
    this.rest
      .get<AdminLocationModel[]>({
        url: `${environment.endpoints.admin}/location`,
      })
      .pipe(
        tap((result) =>
          this.store.dispatch(adminLocationActions.setResultAction({ result }))
        )
      );

  readLocationSelectors = (
    query: string
  ): Observable<SelectItem<KhuyanaSelectItemModel>[]> =>
    this.rest
      .get<SelectItem<KhuyanaSelectItemModel>[]>({
        url: `${environment.endpoints.admin}/location/query`,
        params: { query },
      })
      .pipe(
        tap((items) =>
          this.store.dispatch(adminLocationActions.setQuerySerch({ items }))
        )
      );

  save = ($event?: AdminLocationModel): Observable<AdminLocationModel> => {
    const operation =
      $event && $event.id
        ? this.rest.patch<AdminLocationModel>({
            url: `${environment.endpoints.admin}/location`,
            body: $event,
          })
        : this.rest.put<AdminLocationModel>({
            url: `${environment.endpoints.admin}/location`,
            body: $event,
          });

    return operation.pipe(
      tap((location) => {
        this.message.addSuccess(this.screen.labels.saveSuccess);
        this.store.dispatch(
          adminLocationActions.setLocationDefaultAction(true)
        );
        if ($event && $event.id) {
          this.store.dispatch(
            adminLocationActions.patchLocationAction(location)
          );
        } else if (location.id) {
          this.store.dispatch(adminLocationActions.putLocationAction(location));
        }
      })
    );
  };

  patchStatus = (id?: string): Observable<AdminLocationModel> =>
    this.rest
      .patch<AdminLocationModel>({
        url: `${environment.endpoints.admin}/location/status/{id}`,
        urlParams: { id },
      })
      .pipe(
        tap((location) => {
          this.message.addSuccess(this.screen.labels.saveSuccess);
          this.store.dispatch(
            adminLocationActions.patchLocationAction({
              ...location,
              status: !location.status,
            })
          );
        })
      );
}
